export default __webpack_public_path__ + "static/media/video.0e02e3da.mp4";